import initializeComponent, { store } from '../react-initialize';
import Announcements from './announcements';
import bannerReducer from './reducer';

// Add 'bannerReducer' to our global iFixit Redux Store.
store.injectReducer('bannerState', bannerReducer);

initializeComponent('Announcements', Announcements);
